var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c7e817d38122ebea73c1bcb205f7bb2a45887ad7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"c7e817d38122ebea73c1bcb205f7bb2a45887ad7"};
      